import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import type { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';
import { data } from './techradar.data';

export class TechRadar implements TechRadarApi {
  async load(_id: string | undefined): Promise<TechRadarLoaderResponse> {
    // if needed id prop can be used to fetch the correct data

    // const data = await fetch('https://mydata.json').then(res => res.json());

    // maybe you'll need to do some data transformation here to make it look like TechRadarLoaderResponse

    return data;
  }
}

export type TechRadarPageProps = TechRadarComponentProps & {
  title?: string;
  subtitle?: string;
  pageTitle?: string;
};

export interface TechRadarComponentProps {
  width: number;
  height: number;
  svgProps?: object;
}

export const techRadarProperties: TechRadarPageProps = {
  width: 5,
  height: 800,
  title: 'Meltwater Tech Radar',
  subtitle: 'Pick the recommended technologies for your projects',
  pageTitle: 'Tech Radar - Meltwater - Backstage',
};

export declare const TechRadarProperties: (
  opts: TechRadarPageProps,
) => JSX.Element;
